/**
 * HYPEST — NL breadcrumb-label fix voor Tapita SEO & Speed.
 *
 * Tapita's app-embed schrijft de BreadcrumbList JSON-LD hard in het Engels
 * ("Products"), ook op de Nederlandse taalversie. Dit script draait alleen
 * op nl (voorstel schema-breadcrumb-nl-2026-09-14, Michelle akkoord
 * 2026-09-14) en herschrijft uitsluitend het eerste niveau-label naar
 * "Producten". Op /en/ (en overige locales) doet dit script niets.
 *
 * Terugdraaien: verwijder dit bestand + de <script>-regel in theme.liquid
 * die het inlaadt. Geen andere onderdelen van de site raken dit bestand.
 */
(function () {
  "use strict";

  function fixBreadcrumbLabel() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"][author="tpt"]');
    for (var i = 0; i < scripts.length; i++) {
      var node = scripts[i];
      var raw = node.textContent;
      if (!raw || raw.indexOf("BreadcrumbList") === -1) continue;

      var data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        continue;
      }
      if (!data || data["@type"] !== "BreadcrumbList" || !Array.isArray(data.itemListElement)) {
        continue;
      }

      var changed = false;
      data.itemListElement.forEach(function (item) {
        if (item && item.name === "Products") {
          item.name = "Producten";
          changed = true;
        }
      });

      if (changed) {
        node.textContent = JSON.stringify(data);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixBreadcrumbLabel);
  } else {
    fixBreadcrumbLabel();
  }
})();
